import { EventType, SourcePages, Features, ViewTypes } from 'lib/EventSchema';
import { EventData } from 'lib/EventLogger/Event';

interface MultiMakeModelEventProps {
  url: string;
}

export function multiMakeModelViewEvent({ url }: MultiMakeModelEventProps): EventData {
  return {
    event_type: EventType.view,
    view_type: ViewTypes.pageView,
    source_page: SourcePages.Srp,
    feature: Features.searchV3UnsupportedModal,
    event_context: {
      url,
    },
  };
}

export function multiMakeModelCloseEvent({ url }: MultiMakeModelEventProps): EventData {
  return {
    event_type: EventType.engagement,
    engagement_type: 'close_tap',
    source_page: SourcePages.Srp,
    feature: Features.searchV3UnsupportedModal,
    event_context: {
      url,
    },
  };
}

export function multiMakeModelOpenAppEvent({ url }: MultiMakeModelEventProps): EventData {
  return {
    event_type: EventType.engagement,
    engagement_type: 'open_app_tap',
    source_page: SourcePages.Srp,
    feature: Features.searchV3UnsupportedModal,
    event_context: {
      url,
    },
  };
}
